<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-email`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M43 6a2 2 0 012 2v32a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h38zm-2 4H7v28h34V10zm-4.76 5.042l.076-.006a.5.5 0 01.492.41l.008.09v2.956a1 1 0 01-.327.74l-.094.075-11.765 8.345a.995.995 0 01-.59.157.994.994 0 01-.59-.09l-.123-.072-11.736-8.256a1 1 0 01-.424-.818V15.54a.5.5 0 01.789-.408l11.982 8.49 12.09-8.495a.501.501 0 01.212-.085z"/></svg>
</template>
<script>

export default {
  name: 'IconEmail',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
